<template>
    <div class="fuite wrap">

        <div class="head-fuite">
            <strong>Fuite {{ f.ordre }}</strong>
            <a href="javascript: void 0" class="btn del del-fuite" @click.prevent="confirmDelete">
                <i class="icon-delete"></i>
            </a>
            <a href="javascript: void 0" class="btn photo" @click="triggerPhoto">
                PHOTO<i class="icon-photo"></i>
            </a>
            <input type="file" accept="image/*" style="display: none;" ref="inputfuite" @change="updatePhoto">
            <div class="clear"></div>
        </div>

        <div class="img-content">
            <img :src="urlPhoto(f)" alt="">
        </div>

        <textarea placeholder="Décrivez la localisation de la fuite" v-model="f.localisation" maxlength="255"
                  @change="$emit('fuiteUpdated', f)"></textarea>

        <div class="checkfuite">
            <p>RÉPARATION<br>DE LA FUITE</p>
            <div class="check">
                <input title="fuite" type="radio" :id="f.id+'-reparation_ok'" :name="f.id+'-reparation'" :value="true"
                       v-model="f.reparation" @change="$emit('fuiteUpdated', f)">
                <label :for="f.id+'-reparation_ok'" class="btn check">
                    RÉALISÉE
                    <i class="icon-valid"></i>
                </label>
            </div>
            <div class="check">
                <input title="nie" type="radio" :id="f.id+'-reparation_ko'" :name="f.id+'-reparation'" :value="false"
                       v-model="f.reparation" @change="$emit('fuiteUpdated', f)">
                <label :for="f.id+'-reparation_ko'" class="btn check">
                    À FAIRE
                    <i class="icon-valid"></i>
                </label>
            </div>
        </div>

        <div class="clear"></div>

    </div>
</template>

<script>

    import loadImage from 'blueimp-load-image'
    import Config from '../../../../js/config'

    export default {

        data() {
            return {
                f: this.fuite
            }
        },

        props: {
            fuite: {}
        },

        methods: {
            confirmDelete() {
                swal({
                    title: 'Supprimer la fuite ?',
                    text: 'Cette action est irréversible.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Supprimer',
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#d33',
                }).then(() => {
                    this.$emit('delFuite', [this.f.id])
                }, () => {})
            },
            triggerPhoto() {
                this.$refs.inputfuite.click()
            },
            updatePhoto(e) {
                let vueInstance = this;

                loadImage(
                    e.target.files[0],
                    function (img) {
                        if (img instanceof Event) {
                            swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                            return;
                        }
                        vueInstance.f.photo64 = img.toDataURL('image/jpeg', 0.82);
                        vueInstance.$emit('fuiteUpdated', vueInstance.f)
                    },
                    {
                        maxWidth: 600,
                        maxHeight: 600,
                        orientation: true,
                        canvas: true
                    }
                )

            },

            urlPhoto(fuite) {

                // photo64 est à null sur une fuite créée hors ligne, et quand le
                // fichier référencé est introuvable côté API : il faut alors
                // retomber sur photo plutôt que de ne rien afficher
                if (fuite.photo64) {
                    return fuite.photo64
                }

                const photo = fuite.photo;

                if (!photo) { return null }

                // une valeur déjà complète ne doit pas être re-préfixée
                if (_.includes(photo, ';base64') || _.startsWith(photo, 'http')) { return photo }

                const path = _.startsWith(photo, '/') ? photo : '/' + photo;

                return Config.urlAPI + '/upload' + path;

            },
        }

    }

</script>

<style>
    a.del-fuite {
        background-color: #c31616;
    }
</style>



// WEBPACK FOOTER //
// ItemFuite.vue?3a9f1977